<div>
    <h2>{{'mantenimientoProductos.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showErrorWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'mantenimientoProductos.filters.nombre' | translate}}</label>
                <input type="text" formControlName="desProductoDefecto">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="radio-group no-margin-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="this.resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id" style="padding-left: .5rem;">{{'mantenimientoProductos.table.id' | translate}}</th>
                        <th class="string">{{'mantenimientoProductos.table.producto' | translate}}</th>
                        <th class="date-longest">{{'global.fecha.insercionShort' | translate}}</th>
                        <th class="date-longest">{{'global.fecha.actualizacionShort' | translate}}</th>
                        <th class="action"><i class="fas fa-plus" (click)="create()" title="{{'mantenimientoProductos.tituloNew' | translate}}"></i></th>
                    </tr>
                </thead>
                <tbody *ngFor="let producto of productos; let i=index; trackBy: trackByProductoId">
                    <tr>
                      <td class="id" style="padding-left: .5rem;">{{producto.id}}</td>
                      <td class="string">{{producto.desProductoDefecto}}</td>
                      <td class="date-longest">{{producto.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                      <td class="date-longest">{{producto.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                      <td class="multi-actions">
                            <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i, producto)"
                               title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class="fas fa-pencil-alt" app-click-stop-propagation (click)="update(producto)"
                               title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" app-click-stop-propagation [ngClass]="{'disabled': producto.productoEnUso}" (click)="askDelete(producto)"
                               title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="11">
                            <section class="tabs">
                                <ul>
                                    <li [ngClass]="{'active': pestanaActiva[i] === 1}">{{ ('mantenimientoProductos.traduccion' | translate)}}</li>
                                </ul>
                                <content>
                                    <app-asociar-traducciones *ngIf="pestanaActiva[i] === 1" [objeto]="producto" [nombreComponente]="this.nombreComponente" (refresh)="toRefresh($event)"></app-asociar-traducciones>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!productos || (productos && productos.length < 1)">
                    <tr>
                        <td colspan="11">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="productos && productos.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoProductos.tituloEdit' | translate) : ('mantenimientoProductos.tituloNew' | translate)}}</h4>
        </header>
        <app-prd-new-edit [productoId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-prd-new-edit>
    </div>
</div>
